module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductBox":{"button":"Detail","priceWithoutTax":"bez DPH"}},"en":{"ProductBox":{"button":"Detail","priceWithoutTax":"without VAT"}}}')
  delete Component.options._Ctor
}
